import { render, staticRenderFns } from "./automationRuleNew.vue?vue&type=template&id=f6c53cbe&"
import script from "./automationRuleNew.vue?vue&type=script&lang=js&"
export * from "./automationRuleNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports